<template>
  <div>
    <div class="primary--text">
      {{ formType === 'add' ? $t('create_branch') : $t('edit_branch') }}
    </div>

    <form class="form-control" :class="{ 'has-error': errors.has('branchName') }">
      <label>{{ $t('branch_name') }} <span class="red--text">*</span></label>
      <input
        v-model="input.branch_name"
        v-validate="'required'"
        name="branchName"
        type="text"
        :data-vv-as="$t('branch_name')"
      />
      <span v-if="errors.has('branchName')" class="text-error">{{
        errors.first('branchName')
      }}</span>
    </form>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
      <v-btn
        :loading="loading"
        :disabled="loading"
        depressed
        color="primary"
        @click="handleSaveBranch"
        >{{ $t('Save') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import rootsApi from '@/api/roots'
import { mapGetters } from 'vuex'

export default {
  props: ['formType', 'value'],
  data() {
    return {
      input: {
        branch_name: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.value) {
      this.input.branch_name = this.value.branch_name
    }
  },

  methods: {
    async handleSaveBranch() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        const companyId = vm.$route && vm.$route.params.id

        const data = {
          company_id: companyId,
          branch_name: vm.input.branch_name
        }

        vm.$store.dispatch('loading')

        let response = null
        if (vm.formType === 'add') {
          response = await vm.createBranch(data)
        } else {
          Object.assign(data, { id: vm.value.id })
          response = await vm.updateBranch(data)
        }

        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
        vm.loading = false
      }
    },
    async createBranch(payload) {
      try {
        const response = await rootsApi.postCreateBranch({
          data: payload,
          pageId: this.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async updateBranch(payload) {
      try {
        const response = await rootsApi.putUpdateBranch({
          data: payload,
          pageId: this.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleCancel() {
      this.input = {
        branch_name: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Roots/BranchManage.vue